import SummaryDisplayer from './SummaryDisplayer';
import CalculatorFactory from './CalculatorFactory';
import CalculatorStateManager from './CalculatorStateManager';
import PriceBinderFactory from './PriceBinderFactory';
import FieldValidator from './FieldValidator';

export default class PriceManager {
	#pricingContext;
	#priceBinderFactory;
	#calculatorStateManager;
	#calculatorFactory;
	#summaryDisplayer;
	#priceFormatter;

	constructor(priceFormatter, productPrice) {
		this.#priceFormatter = priceFormatter;
		this.#pricingContext = {
			productPrice,
			measurement: 0,
			quantity: 1,
		};
	}

	init(fields) {
		this.#calculatorFactory = new CalculatorFactory(this.#pricingContext);
		this.#calculatorStateManager = new CalculatorStateManager(
			this.#pricingContext
		);
		this.#summaryDisplayer = new SummaryDisplayer(this.#priceFormatter);
		this.#priceBinderFactory = new PriceBinderFactory(
			this.#calculatorFactory,
			this.#summaryDisplayer,
			this.#priceFormatter
		);

		Array.from(fields).forEach((field) => {
			if (FieldValidator.hasValidPricing(field)) {
				this.register(field);
			}
		});

		this.#calculatorStateManager.notify();
	}

	initCalculatorState() {
		this.#calculatorStateManager.initEvents();
	}

	register(field) {
		try {
			if (field.has_options && field.has_price_in_options) {
				field.options.forEach((option) => {
					if (!FieldValidator.isValidOption(option)) {
						return;
					}

					const price = option.price_type === 'percent' ? option.price : option.price_display;

					const priceBinder = this.#priceBinderFactory.createBinder(
						field.type,
						field.id,
						field.title,
						option.price_type,
						price,
						option.calculation_type,
						{
							optionLabel: option.label,
							optionValue: option.value,
						}
					);
					priceBinder.initEvents();
					this.#calculatorStateManager.subscribe(priceBinder);
				});
			} else {
				const price = field.price_type === 'percent' ? field.price : field.price_display;

				const priceBinder = this.#priceBinderFactory.createBinder(
					field.type,
					field.id,
					field.title,
					field.price_type,
					price,
					field.calculation_type
				);
				priceBinder.initEvents();
				this.#calculatorStateManager.subscribe(priceBinder);
			}
		} catch (error) {
			console.error(`Failed to register ${field.id}:`, error);
		}
	}
}
